import { render, staticRenderFns } from "./PDropdown.vue?vue&type=template&id=0f5af0de"
import script from "./PDropdown.vue?vue&type=script&lang=js"
export * from "./PDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports